/* eslint-disable jsx-a11y/anchor-is-valid */

/* eslint-disable react/prop-types */
import React, { useState, useRef } from 'react';
import t from 'prop-types';
import SelectorSesion from './selector-sesion';
import BotonPDF from '../../botones/boton-pdf';
import * as Util from '../../util';

function GestorSesiones(_ref) {
  var visible = _ref.visible,
      idUltimaSesionActiva = _ref.idUltimaSesionActiva,
      sesiones = _ref.sesiones,
      iconoSesion = _ref.iconoSesion,
      textoNuevaSesion = _ref.textoNuevaSesion,
      textoAceptar = _ref.textoAceptar,
      textoSesiones = _ref.textoSesiones,
      textoOrdenarPorFecha = _ref.textoOrdenarPorFecha,
      textoOrdenarAlfabeticamente = _ref.textoOrdenarAlfabeticamente,
      versionVentanaSesiones = _ref.versionVentanaSesiones,
      pdfAyuda = _ref.pdfAyuda,
      textoAyuda = _ref.textoAyuda,
      textoSesionSeleccionada = _ref.textoSesionSeleccionada,
      textoEntrar = _ref.textoEntrar,
      textoImportarSesion = _ref.textoImportarSesion,
      textoExportarSesion = _ref.textoExportarSesion,
      parametrosImportarExportarSesion = _ref.parametrosImportarExportarSesion,
      textoEliminarSesion = _ref.textoEliminarSesion,
      mensajeConfirmarEliminarSesion = _ref.mensajeConfirmarEliminarSesion,
      onNuevaSesion = _ref.onNuevaSesion,
      onEntrar = _ref.onEntrar,
      onImportarSesion = _ref.onImportarSesion,
      onExportarSesion = _ref.onExportarSesion,
      onEliminarSesion = _ref.onEliminarSesion;

  var _useState = useState(idUltimaSesionActiva && sesiones.find(function (sesion) {
    return sesion.id === idUltimaSesionActiva;
  })),
      sesionSeleccionada = _useState[0],
      setSesionSeleccionada = _useState[1];

  var nuevaSesionRef = useRef(); // const importarSesionRef = useRef()
  // early exit

  if (!visible || window.modoTrabajo) {
    return null;
  }

  function handleNuevaSesion() {
    var nombreSesion = nuevaSesionRef.current.value.trim();

    if (nombreSesion === "") {
      return;
    }

    nuevaSesionRef.current.value = "";
    var sesion = sesiones.find(function (sesion) {
      return sesion.nombre === nombreSesion;
    });

    if (!sesion) {
      onNuevaSesion(nombreSesion);
    } else {
      handleSeleccionarSesion(sesion);
    }
  }

  function handleEntrar() {
    sesionSeleccionada && onEntrar && onEntrar(sesionSeleccionada);
  }

  function handleSeleccionarSesion(sesion) {
    setSesionSeleccionada(sesion);
  }

  function handleImportarSesion() {
    if (sesionSeleccionada) {
      var mensajeConfirmarImportarSesion = '¿Importar datos de sesión?';
      var parametroMensajeImportar = parametrosImportarExportarSesion.mensajeImportar;

      if (parametroMensajeImportar) {
        if (parametroMensajeImportar.split('##').length > 1) {
          mensajeConfirmarImportarSesion = parametroMensajeImportar.split('##').join(sesionSeleccionada.nombre);
        } else {
          mensajeConfirmarImportarSesion = parametroMensajeImportar;
        }
      }

      if (!Util.confirm(mensajeConfirmarImportarSesion)) {
        return;
      }

      if (sesionSeleccionada) {
        onImportarSesion && onImportarSesion(sesionSeleccionada);
      }
    }
  }

  function handleExportarSesion() {
    sesionSeleccionada && onExportarSesion && onExportarSesion(sesionSeleccionada);
  }

  function handleEliminarSesion() {
    if (sesionSeleccionada) {
      if (mensajeConfirmarEliminarSesion && !Util.confirm(mensajeConfirmarEliminarSesion)) {
        return;
      }

      if (sesionSeleccionada) {
        onEliminarSesion && onEliminarSesion(sesionSeleccionada);
        setSesionSeleccionada(null);
      }
    }
  }

  var nuevoDisenoSesiones = versionVentanaSesiones || "version1";
  var electronContext = window.electronContext || window.parent.electronContext;
  var visibilidadBotonesImportarExportar = electronContext && parametrosImportarExportarSesion && parametrosImportarExportarSesion.mostrarBotonesElectron || !electronContext && parametrosImportarExportarSesion && parametrosImportarExportarSesion.mostrarBotonesWeb;

  if (nuevoDisenoSesiones === "version2") {
    return React.createElement('div', {
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000
      }
    }, React.createElement('div', {
      className: 'ventanaSesion'
    }, React.createElement('div', {
      className: 'lenguetaSesion'
    }, !iconoSesion && React.createElement('img', {
      src: 'css/imagenes/sesiones/iconoSesion.png',
      alt: 'Session selection'
    }), iconoSesion && React.createElement('img', {
      src: iconoSesion,
      alt: 'Session selection'
    }), React.createElement(BotonPDF, {
      fichero: pdfAyuda,
      clase: 'botonAyudaSesion',
      texto: textoAyuda
    })), React.createElement('div', {
      className: 'gestorSesion'
    }, React.createElement(SelectorSesion, {
      idUltimaSesionActiva: idUltimaSesionActiva,
      sesiones: sesiones,
      textoSesiones: textoSesiones,
      textoOrdenarPorFecha: textoOrdenarPorFecha,
      textoOrdenarAlfabeticamente: textoOrdenarAlfabeticamente,
      sesionSeleccionada: sesionSeleccionada || '',
      onSeleccionarSesion: handleSeleccionarSesion,
      textoNuevaSesion: textoNuevaSesion,
      textoAceptar: textoAceptar,
      onNuevaSesion: onNuevaSesion,
      nuevoDisenoSesiones: nuevoDisenoSesiones
    })), React.createElement('div', {
      className: 'accesoSesion'
    }, React.createElement('div', {
      className: 'edicionSesiones'
    }, React.createElement('label', {
      htmlFor: 'eleccionSesion',
      className: 'etiquetaSesion'
    }, textoSesionSeleccionada, React.createElement('div', {
      className: 'eleccionSesion'
    }, React.createElement('input', {
      type: 'text',
      id: 'eleccionSesion',
      name: 'eleccionSesion',
      value: sesionSeleccionada ? sesionSeleccionada.nombre : ''
    })))), React.createElement('div', {
      className: 'modificarSesion'
    }, visibilidadBotonesImportarExportar && React.createElement('div', {
      className: 'botonEdicionSesiones' + (sesionSeleccionada ? '' : ' desactivado'),
      onClick: handleImportarSesion
    }, textoImportarSesion), visibilidadBotonesImportarExportar && React.createElement('div', {
      className: 'botonEdicionSesiones' + (sesionSeleccionada ? '' : ' desactivado'),
      onClick: handleExportarSesion
    }, textoExportarSesion), React.createElement('div', {
      className: 'botonEdicionSesiones' + (sesionSeleccionada ? '' : ' desactivado'),
      onClick: handleEliminarSesion
    }, textoEliminarSesion)), React.createElement('div', {
      className: 'botonSesion' + (sesionSeleccionada ? '' : ' desactivado'),
      onClick: handleEntrar
    }, textoEntrar))));
  } else {
    // versión 1 (~flash)
    return React.createElement('div', {
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000
      }
    }, React.createElement('div', {
      className: 'ventanaSesion'
    }, React.createElement('div', {
      className: 'lenguetaSesion'
    }, !iconoSesion && React.createElement('img', {
      src: 'css/imagenes/sesiones/iconoSesion.png',
      alt: 'Session selection'
    }), iconoSesion && React.createElement('img', {
      src: iconoSesion,
      alt: 'Session selection'
    })), React.createElement('div', {
      className: 'gestorSesion'
    }, React.createElement('div', {
      className: 'nuevaSesion'
    }, React.createElement('label', {
      htmlFor: 'nuevoNombreSesion',
      className: 'etiquetaSesion'
    }, textoNuevaSesion), React.createElement('div', {
      className: 'nuevoNombreSesion'
    }, React.createElement('input', {
      ref: nuevaSesionRef,
      type: 'text',
      id: 'nuevoNombreSesion',
      name: 'nuevoNombreSesion'
    })), React.createElement('div', {
      className: 'botonSesion',
      onClick: handleNuevaSesion
    }, textoAceptar)), React.createElement(BotonPDF, {
      fichero: pdfAyuda,
      clase: 'botonAyudaSesion',
      texto: textoAyuda
    }), React.createElement(SelectorSesion, {
      idUltimaSesionActiva: idUltimaSesionActiva,
      sesiones: sesiones,
      textoSesiones: textoSesiones,
      textoOrdenarPorFecha: textoOrdenarPorFecha,
      textoOrdenarAlfabeticamente: textoOrdenarAlfabeticamente,
      sesionSeleccionada: sesionSeleccionada || '',
      onSeleccionarSesion: handleSeleccionarSesion
    }), React.createElement('div', {
      className: 'accesoSesion'
    }, React.createElement('label', {
      htmlFor: 'eleccionSesion',
      className: 'etiquetaSesion'
    }, textoSesionSeleccionada), React.createElement('div', {
      className: 'eleccionSesion'
    }, React.createElement('input', {
      type: 'text',
      id: 'eleccionSesion',
      name: 'eleccionSesion',
      value: sesionSeleccionada ? sesionSeleccionada.nombre : ''
    })), React.createElement('div', {
      className: 'botonSesion' + (sesionSeleccionada ? '' : ' desactivado'),
      onClick: handleEntrar
    }, textoEntrar)), React.createElement('div', {
      className: 'edicionSesiones'
    }, visibilidadBotonesImportarExportar && React.createElement('div', {
      className: 'botonEdicionSesiones' + (sesionSeleccionada ? '' : ' desactivado'),
      onClick: handleImportarSesion
    }, textoImportarSesion), visibilidadBotonesImportarExportar && React.createElement('div', {
      className: 'botonEdicionSesiones' + (sesionSeleccionada ? '' : ' desactivado'),
      onClick: handleExportarSesion
    }, textoExportarSesion), React.createElement('div', {
      className: 'botonEdicionSesiones' + (sesionSeleccionada ? '' : ' desactivado'),
      onClick: handleEliminarSesion
    }, textoEliminarSesion)))));
  }
}

GestorSesiones.propTypes = process.env.NODE_ENV !== "production" ? {
  visible: t.bool.isRequired,
  idUltimaSesionActiva: t.string.isRequired,
  sesiones: t.array.isRequired,
  versionVentanaSesiones: t.string,
  iconoSesion: t.string,
  textoNuevaSesion: t.string,
  textoAceptar: t.string,
  textoSesiones: t.arrayOf(t.shape({
    nombre: t.string
  })),
  // mapa de sesiones
  textoOrdenarPorFecha: t.string,
  textoOrdenarAlfabeticamente: t.string,
  textoAyuda: t.string,
  textoSesionSeleccionada: t.string,
  pdfAyuda: t.string,
  textoEntrar: t.string,
  textoImportarSesion: t.string,
  textoExportarSesion: t.string,
  parametrosImportarExportarSesion: t.object,
  textoEliminarSesion: t.string,
  onNuevaSesion: t.func,
  onAyuda: t.func,
  onEntrar: t.func,
  onImportarSesion: t.func,
  onExportarSesion: t.func,
  onEliminarSesion: t.func
} : {};
export default GestorSesiones;